<!-- ============================================================== -->
<!-- Main wrapper - style you can find in pages.scss -->
<!-- ============================================================== -->
<!-- <router-outlet><app-spinner></app-spinner></router-outlet> -->
<!-- <script src="https://maps.googleapis.com/maps/api/js?key={{coolBeans.bimBam}}&libraries=places"></script> -->
<!-- <div>
    {{coolBeans.bimBam}}
</div> -->

<router-outlet></router-outlet>